module.exports = (category, action, label) => {
    const dataLayer = window.dataLayer = window.dataLayer || [];

    dataLayer.push({
        event: 'eventTracking',
        category: category,
        action: action,
        label: label
    });
};


// WEBPACK FOOTER //
// ./js/viscom/viscomjs/analytics/analyticsEvent.js